import Vue from 'vue'
import Vuex from 'vuex'
import Axios from '@/api/Axios'
import ElementUI from 'element-ui'
import {getParams} from '@/api/getUrlParams'

Vue.use(Vuex)
Vue.use(ElementUI)
export default new Vuex.Store({
  strict:false,
  state: {
    scriptId:'',            //上传剧本时填写完第一步基本信息生成剧本ID 上传剧本文件时需要带着此对应ID
    users:'',               //储存用户信息
    areaInfo:'',            //个人信息地区联动
    scriptListInfo:'',      //个人中心投稿
    scriptListTotal:'',     //个人中心投稿总数量
    draftListInfo:'',       //个人中心草稿
    draftListTotal:'',      //个人中心草稿总数量
    scriptInfoById:'',      //根据ID获取剧本信息
    messageAll:'',          //个人中心所有消息
    messageUnread:'',       //个人中心未读消息
    mesUnreadTotal:'',      //个人中心未读消息总数量
    mesReadTotal:'',        //个人中心已读消息总数量
    mesAllTotal:'',         //个人中心全部消息总数量
    messageRead:'',         //个人中心已读消息
    scriptAreaList:'',      //剧本专区首页最新剧本、热门剧本
    oneCate:''              //基本信息页点击下一步是储存一级分类是电视剧还是电影  控制上传文件页表格行数
  },
  mutations: {
    updateScriptId(state, payload) {
      state.scriptId=payload
    },
    userInfo(state, users){
      state.users=users;
    },
    areaInfo(state,area){
      state.areaInfo=area;
    },
    userCenterScriptList(state,sList){
      state.scriptListInfo=sList;
    },
    userCenterScriptTotal(state,sTotal){
      state.scriptListTotal=sTotal;
    },
    userCenterDraftList(state,dList){
      state.draftListInfo=dList;
    },
    userCenterDraftTotal(state,dTotal){
      state.draftListTotal=dTotal;
    },
    updateScriptInfoById(state,idScript){
      state.scriptInfoById=idScript
    },
    userCenterMessageAll(state,mAll){
      state.messageAll=mAll
    },
    userCenterAllMesTotal(state,mAllTotal){
      state.mesAllTotal=mAllTotal
    },
    userCenterMessageUnread(state,mUnread){
      state.messageUnread=mUnread
    },
    userCenterUnreadMesTotal(state,mUnreadTotal){
      state.mesUnreadTotal=mUnreadTotal
    },
    userCenterMessageRead(state,mRead){
      state.messageRead=mRead
    },
    userCenterReadMesTotal(state,mReadTotal){
      state.mesReadTotal=mReadTotal
    },
    upDateScriptAreaList(state,sAreaList){
      state.scriptAreaList=sAreaList
    }
  },
  actions: {
    //读取用户信息
    readUsers({commit}){
      Axios.get('user/info','').then(
        response=>{
          if(response.data.code==200&&response.data.status=="success"){
            let users=response.data.data
            commit('userInfo',users);
          }
        },
        error=>{
          console.log(error)
        }
      )
    },
    //读取地区联动
    readArea({commit}){
      Axios.get('area','').then(
        response=>{
          if(response.data.code==200&&response.data.status=="success"){
            let locationInfo=response.data.data
            commit('areaInfo',locationInfo)
          }
        },
        error=>{
          console.log(error)        
        }
      )
    },
    //个人中心读取个人投稿
    readScriptList({commit}){
      Axios.get('article/contribute',{'num':6}).then(
        response=>{
          if(response.data.code==200&&response.data.status=="success"){
            let scriptList=response.data.data.lists
            let scriptTotal=response.data.data.all_count
            commit('userCenterScriptList',scriptList)
            commit('userCenterScriptTotal',scriptTotal)
          }
        },
        error=>{
          console.log(error)
        }
      )
    },
    //个人中心读取个人草稿
    readDraftList({commit}){
      Axios.get('article/draft',{'num':6}).then(
        response=>{
          if(response.data.code==200&&response.data.status=="success"){
            let draftList=response.data.data.lists
            let draftTotal=response.data.data.all_count
            commit('userCenterDraftList',draftList)
            commit('userCenterDraftTotal',draftTotal)
          }
        },
        error=>{
          console.log(error)
        }
      )
    },
    //修改草稿或续传剧本时根据ID获取对应稿件写的基本信息和文件列表
    readScriptInfoById({commit}){
      let getId=getParams('id')
      let getStatus=getParams('s')
      //获取剧本状态值 如果为1则是续传 需要走单独的续传接口获取剧本信息
      if(getId&&getStatus==1){
        Axios.get('/article/continue/'+getId).then(
          response=>{
            if(response.data.code==200&&response.data.status=="success"){
              let idScript=response.data.data;
              commit('updateScriptInfoById',idScript)
            }
          },
          error=>{
            console.log(error)
          }
        )
      }
      //如果剧本状态为-1则是草稿箱修改操作
      if(getId&&getStatus==-1){
        Axios.get('article/edit/'+getId).then(
          response=>{
            if(response.data.code==200&&response.data.status=="success"){
              let idScript=response.data.data;
              commit('updateScriptInfoById',idScript) 
            }
          },
          error=>{
            console.log(error)
          }
        )
      }
      //如果剧本状态为-2则是草稿箱中审核未通过剧本
      if(getId&&getStatus==-2){
        Axios.get('article/edit/'+getId).then(
          response=>{
            if(response.data.code==200&&response.data.status=="success"){
              let idScript=response.data.data;
              commit('updateScriptInfoById',idScript)
            }
          },
          error=>{
            console.log(error)
          }
        )
      }
    },
    //读取个人中心所有消息
    readAllMessage({commit}){
      Axios.get('message/all','').then(
        response=>{
          if(response.data.code==200&&response.data.status=="success"){
            let messageAll=response.data.data.lists;
            let allMesTotal=response.data.data.all_count;
            commit('userCenterMessageAll',messageAll)
            commit('userCenterAllMesTotal',allMesTotal)
          }
        },
        error=>{
          console.log(error)
        }
      )
    },
    //读取个人中心未读消息
    readUnreadMessage({commit}){
      Axios.get('message/unread','').then(
        response=>{
          if(response.data.code==200&&response.data.status=="success"){
            let messageUnread=response.data.data.lists;
            let unReadMesTotal=response.data.data.all_count;
            commit('userCenterMessageUnread',messageUnread)
            commit('userCenterUnreadMesTotal',unReadMesTotal)
          }
        },
        error=>{
          console.log(error)
        }
      )
    },
    //读取个人中心已读消息
    readReadMessage({commit}){
      Axios.get('message/read','').then(
        response=>{
          if(response.data.code==200&&response.data.status=="success"){
            let messageRead=response.data.data.lists;
            let readMesTotal=response.data.data.all_count;
            commit('userCenterMessageRead',messageRead)
            commit('userCenterReadMesTotal',readMesTotal)
          }
        },
        error=>{
          console.log(error)
        }
      )
    },
    //剧本专区首页读取剧本列表
    getScriptAreaList({commit}){
      Axios.get('article/module','').then(
        response=>{
          if(response.data.code==200&&response.data.status=="success"){
            commit('upDateScriptAreaList',response.data.data)
          }
        },
        error=>{
          console.log(error)
        }
      )
    }
  },
  getters: {
    scriptId:state => state.scriptId,
    users:state=>state.users,
    areaInfo:state=>state.areaInfo,
    scriptListInfo:state=>state.scriptListInfo,
    scriptListTotal:state=>state.scriptListTotal,
    draftListInfo:state=>state.draftListInfo,
    draftListTotal:state=>state.draftListTotal,
    messageAll:state=>state.messageAll,
    messageUnread:state=>state.messageUnread,
    mesUnreadTotal:state=>state.mesUnreadTotal,
    mesReadTotal:state=>state.mesReadTotal,
    mesAllTotal:state=>state.mesAllTotal,
    messageRead:state=>state.messageRead,
    scriptInfoById:state=>state.scriptInfoById,
    scriptAreaList:state=>state.scriptAreaList
  }
})
